class SearchableFaq extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    this.searchInput = this.querySelector('[data-faq-search]');
    this.items = Array.from(this.querySelectorAll('[data-faq-item]'));
    this.emptyMessage = this.querySelector('[data-faq-empty]');

    this.searchInput?.addEventListener('input', this.#filterItems, {
      signal: this.#controller.signal,
    });

    this.#filterItems();
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  #normalize(value) {
    return value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLocaleLowerCase()
      .trim();
  }

  #filterItems = () => {
    const query = this.#normalize(this.searchInput?.value || '');
    let visibleItems = 0;

    this.items.forEach((item) => {
      const question = item.querySelector('[data-faq-question]')?.textContent || '';
      const isMatch = this.#normalize(question).includes(query);

      item.hidden = !isMatch;

      if (isMatch) {
        visibleItems += 1;
      } else {
        item.querySelector('details')?.removeAttribute('open');
      }
    });

    if (this.emptyMessage) {
      this.emptyMessage.hidden = visibleItems !== 0;
    }
  };
}

if (!customElements.get('searchable-faq')) {
  customElements.define('searchable-faq', SearchableFaq);
}
